import React from "react";

import { Container, Spinner } from "./styles";

const Loader: React.FC<{ color?: string; className?: string; style?: any; containerClass?: string }> = (props) => (
  <Container className={props.containerClass || ""}>
    <Spinner className={'default ' + props.className || undefined} style={props.style || {}}/>
  </Container>
);

export default Loader;
